import { TTS_DEFAULT_LANG_CODE, TTS_DEFAULT_SPEAKER_ID } from 'consts/tts'
import { createContext } from 'react'

export const TtsItemSpeakerFlyoutContext = createContext<{
  ttsItemLangCode: string
  ttsActiveSpeakerId: number
  ttsItemInstruction: string
  handleLanguageChange: (langCode: string) => void
  handleVoiceChange: (speakerId: number) => void
  handleToneChange: (instruction: string) => void
  hasEmotion: boolean
  isAnyChanges: boolean
  handleConfirmButton: () => void
}>({
  ttsItemLangCode: TTS_DEFAULT_LANG_CODE,
  ttsActiveSpeakerId: TTS_DEFAULT_SPEAKER_ID,
  ttsItemInstruction: '',
  handleLanguageChange: () => {},
  handleVoiceChange: () => {},
  handleToneChange: () => {},
  hasEmotion: false,
  isAnyChanges: false,
  handleConfirmButton: () => {}
})
